/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Trend_LeadInputs */

const en_fw_bm_trend_lead = /** @type {(inputs: Fw_Bm_Trend_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First-pass rate across every sampled task, month by month.`)
};

const id_fw_bm_trend_lead = /** @type {(inputs: Fw_Bm_Trend_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat lolos percobaan pertama dari seluruh task tersampel, bulan demi bulan.`)
};

/**
* | output |
* | --- |
* | "First-pass rate across every sampled task, month by month." |
*
* @param {Fw_Bm_Trend_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_trend_lead = /** @type {((inputs?: Fw_Bm_Trend_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Trend_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_trend_lead(inputs)
	return en_fw_bm_trend_lead(inputs)
});